type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * Longest Channel Name the form lets through.
 *
 * OBSERVED, not documented: in the release 29817 browser pass a 255-character
 * name saved and a 300-character one was refused by the backend (surfacing as a
 * raw `ActionWebhookErrorResponse` toast). The exact backend limit between the
 * two has not been established; if it is found, this is the one place to change.
 *
 * Limitation: the check is `value.length`, which counts UTF-16 code units, not
 * characters. A character outside the Basic Multilingual Plane (most emoji)
 * counts as two, so 200 such characters (400 units) are refused although they
 * are fewer than 255 characters. Which unit the backend counts is not known.
 * The voice channel form does not apply this rule at all: no bound has been
 * observed for voice channel names.
 */
export const CHANNEL_NAME_MAX_LENGTH = 255;

/**
 * The react-hook-form rules for the Channel Details Name input (create and
 * edit). A blank or whitespace-only name blocks Save instead of PUTting
 * `widget_name: ''`; an over-long one blocks Save with a readable message
 * instead of reaching the backend.
 *
 * No English fallback after `t(...)`: i18next answers a missing key with the
 * key itself, never an empty string, so a `|| '…'` could fire only for a key
 * whose value is the empty string, and both keys are non-empty in every
 * pro-studio locale (`channel-details.json`).
 */
export const buildChannelNameRules = (t: Translate) => {
  const requiredMessage = t(
    'pro-studio/channel-details:form.validation-messages.name'
  );
  return {
    required: requiredMessage,
    validate: (value: string): true | string => {
      if (value.trim().length === 0) return requiredMessage;
      if (value.length > CHANNEL_NAME_MAX_LENGTH) {
        return t(
          'pro-studio/channel-details:form.validation-messages.name-too-long',
          { max: CHANNEL_NAME_MAX_LENGTH }
        );
      }
      return true;
    },
  };
};
